import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataFimProrrogada = (): TabelaColuna => ({
  Chave: 'dataFimProrrogada',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataFimProrrogada)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Data Fim Pror.</div>
})
